import Ext from 'Ext'
import AbstractPickerButton from './at_abstract_picker_button'
import DatePickerMenu from './at_date_picker_menu'

const DateSelector = Ext.extend(AbstractPickerButton,
{
    showToday: true,
    showOkCancelButtons: true,
    scheduleCalculator: null,
    renderDateMenuToContent: true,
    menuListeners:
    {
        select : function (m, d)
        {
            if( this.date || !this.menu.wasSelectionOnHide )
                this.updateValueAndFireIfChanged( m, d );
            else
                this.menu.onDatePickerCancel();
        },

        datePickerUpdate : function(date)
        {
            // display the given date, but don't actually change the date
            if( this.date )
                this.displayValue(date);
        },

        datePickerCancel : function()
        {
            // display the stored value
            this.displayValue(this.getValue());
            // rollback changes made in the picker
            this.menu.picker.setValue( this.getValueOrDefaultValue() );
        }
    },

    getValueOrDefaultValue: function()
    {
        return this.getValue() ? this.getValue() : window.currentUserTime().clearTime();
    },

    createMenu: function()
    {
        return new DatePickerMenu(
                {
                    mode: "dynamic",
                    minDate: this.minValue,
                    maxDate: this.maxValue,
                    format: this.format,
                    showToday: this.showToday,
                    showOkCancelButtons: this.showOkCancelButtons,
                    scheduleCalculator: this.scheduleCalculator,
                    startDay: this.weekStartDay,
                    value: this.getValueOrDefaultValue(),
                    minText: this.minText,
                    maxText: this.maxText,
                    parentEl: this.renderDateMenuToContent ? this.renderTo : null,
                });
    },

    hideMenuOnScrollOrResize: function()
    {
        if(this.getValue())
            this.menu.picker.selectActiveDate();
        this.hideMenu(); // hides the menu faster than the previous call
    }
});

export default DateSelector



// WEBPACK FOOTER //
// ./web/js/controls/dateControls/DateSelector.js